import {CmsContent} from "../../Model/CmsContent/CmsContent";
import {optHtmlContent, renderDynamicContent} from "../../Utilities/CmsUtilities";
import * as React from "react";
import HeaderFooterWrapper from "../../Components/Navigation/HeaderFooterWrapper";
import {Navigate} from "react-router-dom";
import {SALES_PORTAL_ROUTES} from "../../Routes/SalesPortalRoutes";
import {ApplicationContext} from "../../ApplicationContext";
import CmsIframe from "../../Components/CmsIframe/CmsIframe";
import {COUNTER_PAGE_LOAD} from "../../Service/CounterMetricsProvider";

interface CoverageCheckerPageProps {

    /**
     * Array of all Sales Portal content currently stored in the CMS.
     */
    readonly cmsContent: CmsContent[]

}

/**
 * Function will render the coverage checker page which will let prospective customer check how good the
 * network is in specific areas.
 */
const CoverageCheckerPage = (props: CoverageCheckerPageProps): JSX.Element => {

    const applicationContext = React.useContext(ApplicationContext)

    const optCoverageCheckerPage = optHtmlContent(props.cmsContent, "sp-page-coverage-checker")
    const optCoverageCheckerWidget = props.cmsContent.find((content) => content.reference === "coverage-checker")

    React.useEffect(() => {
        window.scrollTo(0, 0)
        COUNTER_PAGE_LOAD.emit({
            severityNumber: 9,
            severityText: "INFO",
            body: "",
            attributes: {"page": "/coverage-checker"}
        });
    }, [])

    if (optCoverageCheckerPage && optCoverageCheckerWidget && optCoverageCheckerWidget.jsonContent) {
        return (
            <HeaderFooterWrapper cmsContent={props.cmsContent} variant="primary">
                {renderDynamicContent(optCoverageCheckerPage, [
                    {
                        key: "COVERAGE_CHECKER",
                        value: <CmsIframe cmsIframeSchema={optCoverageCheckerWidget.jsonContent}/>
                    }
                ])}
            </HeaderFooterWrapper>
        )
    } else { // Fallback to generic error page.
        return <Navigate to={SALES_PORTAL_ROUTES.NotFound(applicationContext.urlContext)}/>
    }

}

export default CoverageCheckerPage
